import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigUserPermissionService {
  private configUrl = 'assets/UserRolesSetup/UserPermission.json';

  constructor(private http: HttpClient) { }

  getRequiredRoles(): Observable<any> {
    return this.http.get<any>(this.configUrl);
  }
}
